export default "__VITE_ASSET__DdhdmRVl__"